import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalType, NonPersistedModalName } from '@shared/models/modal.model';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { EventManager } from '@app/shared/utils/event-manager';
import { LoggerService } from '@app/shared/services/logger.service';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { UserService } from '@app/shared/services/user.service';
import { OneSignalService, TagName } from '@app/shared/services/one-signal.service';
import { Observable } from 'rxjs';
import { SharedModule } from '@app/shared/shared.module';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { DividerComponent } from '@app/shared/components/divider/divider.component';
@TakeUntilDestroy
@Component({
  selector: 'slotcom-account-deletion-step3',
  templateUrl: './account-deletion-step3.component.html',
  styleUrls: ['./account-deletion.component.scss'],
  standalone: true,
  imports: [SharedModule, ButtonComponent, DividerComponent],
})
// eslint-disable-next-line
export class AccountDeletionStep3 implements OnInit {
  logger = inject(LoggerService);
  private authService = inject(AuthenticationService);
  private userService = inject(UserService);
  private eventManager = inject(EventManager);
  private oneSignalService = inject(OneSignalService);
  info = inject<Modal>(MAT_DIALOG_DATA);

  deactivationDays: number;

  componentDestroy: () => Observable<unknown>;

  ngOnInit() {
    this.deactivationDays = this.info.data;
  }

  stepForward() {
    this.eventManager.closeAllModals();
    this.oneSignalService.sendTag(TagName.AccountDeletion, new Date()).catch((e) => this.logger.error(e));
    this.userService
      .startAccountDeletion()
      .pipe()
      .subscribe(() => {
        this.authService.logout().catch((e) => this.logger.error(e));
      });
  }

  closeModal() {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.AccountDeletionStep3, ModalType.View));
  }
}
